import React from 'react'
import Select, { MultiValue } from 'react-select'
import { FormField } from '../ui/Form'

interface Option {
  value: string
  label: string
}

interface MultiSelectFieldProps {
  label: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  options: Option[]
  value: MultiValue<Option>
  onChange: (selected: MultiValue<Option>) => void
  placeholder?: string
  helpText?: string
}

const MultiSelectField: React.FC<MultiSelectFieldProps> = ({
  label,
  icon,
  options,
  value,
  onChange,
  placeholder = 'Seleccionar...',
  helpText
}) => {
  return (
    <FormField
      label={label}
      helpText={helpText}
      icon={icon}
    >
      <Select<Option, true>
        isMulti
        options={options}
        value={value}
        onChange={onChange}
        className="basic-multi-select"
        classNamePrefix="select"
        placeholder={placeholder}
      />
    </FormField>
  )
}

export default React.memo(MultiSelectField)

